export default __webpack_public_path__ + "static/media/208.453af3ed.png";